import { mapState, mapMutations, mapGetters } from 'vuex';

import consumer from '../../../channels/consumer';

import store from '../..//bot/store/index';

import { loadItemsCategoryList } from '../../check_prices/api/index';
import { createClient, validateClient } from '../../bot/api/client';
import { createWarehouserental, getCountryInformation } from '../../bot/api/warehouse_rental';
import { addItemsToRental } from '../../bot/api/warehouse_list_items';

export default {
  store,

  data () {
    return {
      currentStep: 'volume',
      loading: false,
      errorMessage: null,
      directionAnimation: 'slideRight',
      customErrorActive: false
    }
  },

  mounted () {
    loadItemsCategoryList()
      .then((response) => this.setItemsCategoryList(response.data));

    getCountryInformation()
      .then((response) => this.setCountryInformation(response.data));
  },

  computed: {
    ...mapState(['itemsCategoryList', 'warehouseRental', 'client', 'addressConfig', 'countryInformation']),

    ...mapGetters(['isDisabledDate']),

    warehouseListItems: {
      get() {
        return this.$store.state.warehouseListItems;
      },
      set(value) {
        this.$store.commit('setWarehouseListItems', value);
      }
    },

    currentTitle() {
      switch (this.currentStep) {
        case 'volume':
          return '¡Hola! Tenemos los mejores precios <br class="d-none d-lg-block" /> en renta de bodegas. ¿Quieres ver?';

        case 'packing-list':
          return 'Ingresa los principales ítems que guardarás en la bodega. <br class="d-none d-lg-block" /> Es más rápido de lo que crees ;)';

        case 'start-rental':
          return '<small>Genial, sólo dos preguntas más.</small> <br /> ¿Qué día aprox. iniciarías tu arriendo?';

        case 'desired-location':
          return `Perfecto. Ahora ingresa tu <span class="font-gotham-m text-decoration-underline">${this.countryInformation.comuneName}</span> o <span class="font-gotham-m text-decoration-underline">código postal</span> <br class="d-none d-lg-block" /> para revisar nuestra cobertura en tu zona.`;

        case 'client-info':
          return '<small>¡Todo listo! ;)</small> <br /> Ingresa tu email y celular para enviarte tu cotización';

        case 'loading':
          return 'Espera unos segundos… <br class="d-none d-lg-block" /> estamos calculando tu precio ;)';
      }
    },

    titleTag() {
      switch(this.currentStep) {
        case 'volume':
          return 'h1';

        default:
          return 'h2';
      }
    },

    nextStepButtonName() {
      switch (this.currentStep) {
        case 'volume':
          return 'VER PRECIOS';

        case 'client-info':
          return 'FINALIZAR';

        default:
          return 'SIGUIENTE';
      }
    },

    canGoBack() {
      return !['volume', 'loading'].includes(this.currentStep);
    },

    loadingStep () {
      return this.currentStep === 'loading';
    },

    enableNextStepButton() {
      if (this.loading) return false;

      switch (this.currentStep) {
        case 'volume':
          return this.warehouseRental.volume !== null && this.warehouseRental.volume >= 0;

        case 'packing-list':
          return this.warehouseListItems.length > 0;

        case 'start-rental':
          return (this.warehouseRental.startRental && !this.isDisabledDate(this.warehouseRental.startRental)) || this.warehouseRental.indefiniteStartRental;

        case 'desired-location':
          return this.addressConfig.stateZoneId && this.addressConfig.googleOptionSelected;

        case 'client-info':
          const values = [this.client.name, this.client.email, this.client.cellphone, this.client.acceptTermsAndConditions];

          return values.find(value => [null, '', false].includes(value)) === undefined
      }

      return false;
    },

    customPackingList () {
      return this.warehouseRental.volume === 0;
    },

    desiredLocationAlternativeText () {
      let stateZone = '';

      switch (this.countryInformation.iso) {
        case 'CL':
          stateZone = 'Santiago';
          break;

        case 'CO':
          stateZone = 'Bogotá';
          break;

        case 'MX':
          stateZone = 'CDMX y el Estado de México';
          break;
      }

      return `Prueba ingresando manualmente una ${this.countryInformation.comuneName} en nuestras zonas de operación. Actualmente tenemos bodegas en ${stateZone}`;
    },

    startRentalAnswerMessage () {
      if (this.warehouseRental.startRental) {
        return '¡Perfecto! Si más adelante necesitas cambiar la fecha, no hay problema ;)';
      } else if (this.warehouseRental.indefiniteStartRental) {
        return 'No hay problema, lo podemos editar después cuando quieras ;)';
      }
    }
  },

  methods: {
    ...mapMutations(['setItemsCategoryList', 'setBlockedDates', 'setCountryInformation']),

    resetErrorMessage() {
      this.errorMessage = null;
    },

    setErrorMessage(message) {
      this.errorMessage = message;
    },

    backStep() {
      this.directionAnimation = 'slideLeft';

      switch (this.currentStep) {
        case 'packing-list':
          this.currentStep = 'volume';
          break;

        case 'start-rental':
          this.currentStep = this.customPackingList ? 'packing-list' : 'volume';
          break;

        case 'desired-location':
          this.currentStep = 'start-rental';
          break;

        case 'client-info':
          this.currentStep = 'desired-location';
          break;
      }
    },

    printErrors() {
      switch (this.currentStep) {
        case 'volume':
          this.setErrorMessage('Selecciona el volumen que necesitas, puedes modificarlo después ;)');
          break;

        case 'packing-list':
          this.setErrorMessage('Ingresa por lo menos un ítem a tu inventario, puedes modificarlo después ;)');
          break;

        case 'start-rental':
          this.setErrorMessage('Selecciona una fecha estimada de ingreso, puedes modificarlo después ;)');
          break;

        case 'desired-location':
          this.setErrorMessage('Selecciona una dirección de Google o del mapa, puedes modificarla después ;)');
          break;

        case 'client-info':
          this.setErrorMessage('Ingresa todos los datos, puedes modificarlos después ;)');
          break;
      }
    },

    sendMetrics() {
      if (typeof gtag !== "undefined"){
        gtag('event', 'warehouseRentalQuoted');
        gtag('event', 'conversion', {'send_to': 'AW-864591653/NmPHCKqOsYcBEKW-opwD'});
      }
      // Agregar evento GA4
      // ga('send', 'pageview', '/bot/warehouse/bot-ok');
    },

    async validateClient() {
      try {
        const response = await validateClient({
          client: {
            email: this.client.email,
            cellphone: this.client.cellphone,
            cellphone_country_code_name: this.client.cellphoneCountryCodeName,
            cellphone_country_code: `+${this.client.cellphoneCountryCode}`
          }
        });

        if (response.data.status === 400) {
          if (!response.data.email && !response.data.phone) {
            this.setErrorMessage('Ingresa un email y celular válido para enviarte tu cotización ;)');
          } else if (!response.data.email) {
            this.setErrorMessage('Ingresa un email válido para enviarte tu cotización ;)');
          } else {
            this.setErrorMessage('Ingresa un celular válido para terminar ;)');
          }

          this.loading = false;
          this.customErrorActive = true;
        } else {
          this.customErrorActive = false;
          this.createClient();
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    async createClient() {
      try {
        const response = await createClient({
          client: {
            name: this.client.name,
            email: this.client.email,
            cellphone: this.client.cellphone,
            accept_terms_and_conditions: this.client.acceptTermsAndConditions,
            cellphone_country_code: this.client.cellphoneCountryCode,
          }
        });
        this.client.id = response.data.id;

        this.createWarehouseRental();

      } catch (error) {
        console.log(error);
        this.setErrorMessage('Ocurrió un error al crear tu cuenta, intenta de nuevo ;)');
      }
    },

    async createWarehouseRental() {
      try {
        const response = await createWarehouserental({
          warehouse_rental: {
            client_id: this.client.id,
            volume: this.warehouseRental.volume,
            desired_location: this.warehouseRental.desiredLocation,
            start_rental: this.warehouseRental.startRental,
            can_move_items: this.warehouseRental.canMoveItems,
            state_zone_id: this.warehouseRental.stateZoneId,
            indefinite_start_rental: this.warehouseRental.indefiniteStartRental
          }
        });

        this.warehouseRental.id = response.data.data.attributes.id;
        this.warehouseRental.token = response.data.data.attributes.token;

        this.loadCable();
        this.createWarehouseListItem();
      } catch (error) {
        console.log(error);
      }
    },

    loadCable () {
      const that = this;

      window.onbeforeunload = null;

      const redirectFunction = () => {
        window.location.href = `/bodegas/ver-cotizacion/${this.warehouseRental.token}`;
      }

      consumer.subscriptions.create(
        {
          channel: 'WebWarehouseNotificationsChannel',
          warehouse_id: this.warehouseRental.id
        },
        {
          received (data) {
            setTimeout(redirectFunction, 2500);

            that.sendMetrics();
          }
        }
      );
    },

    async createWarehouseListItem() {
      await this.$recaptchaLoaded();

      let items = {};

      if (this.customPackingList) {
        Object.assign(
          items,
          this.warehouseListItems.map(item => {
            return {
              moving_item_id: item.movingItemId,
              count: item.count
            };
          })
        )
      }

      const body = {
        "g-recaptcha-response-data": {
          algorithmwarehouses: await this.$recaptcha('algorithmwarehouses')
        },
        "g-recaptcha-response": "",
        warehouse_list_items: items
      };

      try {
        addItemsToRental(this.warehouseRental.id, body);
      } catch (error) {
        console.log(error);
      }
    },

    async nextStep() {
      this.resetErrorMessage();

      if (!this.enableNextStepButton) {
        this.printErrors();
        this.loading = false;
        return;
      }

      this.directionAnimation = 'slideRight';

      switch (this.currentStep) {
        case 'volume':
          this.currentStep = this.customPackingList ? 'packing-list' : 'start-rental';
          window.onbeforeunload = function () {
            return 'Estás a la mitad de tu cotización, ¿seguro que quieres salir?';
          };
          break;

        case 'packing-list':
          this.currentStep = 'start-rental';
          break;

        case 'start-rental':
          this.currentStep = 'desired-location';
          break;

        case 'desired-location':
          this.currentStep = 'loading';
          this.loading = true;

          const callback = () => {
            this.currentStep = 'client-info';
            this.loading = false;
          };

          setTimeout(callback, 6000);
          break;

        case 'client-info':
          this.loading = true;

          this.validateClient();
          break;
      }
    }
  }
}